import { gql } from "@apollo/client";

export const GET_ASSET_RISK = gql`
    query GetAssetRisk($propertyIds: [ID!]!, $crremCategories: [CrremCategory!]!) {
        getAssetRiskChartData(propertyIds: $propertyIds) {
            propertyId
            summary {
                emissionIntensity
                energyIntensity
                projectedEmissionIntensity
                projectedEnergyIntensity
                year
            }
        }

        getCrremPathways(
            categories: $crremCategories
            countries: "DK"
            versions: "v203"
        ) {
            crremCategory
            color
            value
            year
            unit
            version
            country
            target
        }
    }
`;
